<div mat-dialog-content>
  <p>{{ data }}</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="exit()" class="text-right" data-test="server-unavailable-btn-ok">OK</button>
</div>
